import { determineYearsOfCollege } from "../objects/determine_years_of_college";
import { rollForwardDate } from "../objects/roll_forward_date_function";

const calculateYearsOfCollege = (hadJobPreviously, nbrYearsSinceJob, currentNbrYearsCollege,
        relatedCareers, currentCareerName, careerNbrMonths, totalGameNbrYearsCollege,
        currentGameDate, newJob) => {
    let reducedNbrYearsCollege = 0;
    let prevJobText = "";
    if (hadJobPreviously === true){
        if (+nbrYearsSinceJob > 5){
            reducedNbrYearsCollege = (+newJob.nbrYearsCollege * .50);
        }else{
            if (nbrYearsSinceJob > 1){
                reducedNbrYearsCollege = (+newJob.nbrYearsCollege * .75);
            }else{
                reducedNbrYearsCollege = +newJob.nbrYearsCollege;
            }
        }
        if (reducedNbrYearsCollege < newJob.nbrYearsCollege){
            prevJobText = "You had the job of " + newJob.careerName  + " previously " +
                "but it has been about " + nbrYearsSinceJob + 
                " years since you had this job.  So you need " +
                "to go back to college to refresh and update your knowledge."
        }
    }else{
        reducedNbrYearsCollege = determineYearsOfCollege(newJob.nbrYearsCollege,
            currentNbrYearsCollege, relatedCareers , currentCareerName , 
            careerNbrMonths);
    }        
     
    const adjustedNbrYearsCollege = newJob.nbrYearsCollege - reducedNbrYearsCollege;
    // calculate the total number of years that this player will have been in college
    const totalNbrYearsCollege = +totalGameNbrYearsCollege + adjustedNbrYearsCollege;
    let requiresCollege = false;
    let collegeWhenWorking = 0;
    let actualNbrYearsCollege = 0;
    let collegeRequiredText = "";
    if (adjustedNbrYearsCollege === 0){
        requiresCollege = false;
        newJob.jobStartDate = currentGameDate;
    }else{
        requiresCollege = true;
        collegeWhenWorking = (adjustedNbrYearsCollege * .5)
        actualNbrYearsCollege = adjustedNbrYearsCollege + collegeWhenWorking;
        let collegeNbrMonths = actualNbrYearsCollege * 12;
        newJob.jobStartDate = rollForwardDate(currentGameDate, collegeNbrMonths);
        collegeRequiredText = "The new job you have chosen will not start " +
        "immediately.  Review the 'Expected Start Date of New Job' displayed below."
    }

    const returnObj = {reducedNbrYearsCollege: reducedNbrYearsCollege, prevJobText: prevJobText,
    adjustedNbrYearsCollege: adjustedNbrYearsCollege, totalNbrYearsCollege: totalNbrYearsCollege,
    requiresCollege: requiresCollege, collegeWhenWorking: collegeWhenWorking,
    actualNbrYearsCollege: actualNbrYearsCollege, collegeRequiredText: collegeRequiredText
    };
    return returnObj;
}
export default calculateYearsOfCollege;